import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EditorConfigService } from './../../../../shared/services/angular-editor.service';
import { MediaFileService } from './../../../../shared/services/media-file.service';
import { CmsPageService } from './../../../../shared/services/cms-page.service';
import { ToastrService } from 'ngx-toastr';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Subscription } from 'rxjs/internal/Subscription';
import { IMediaFile } from '../../../../_models/cms/IMediaFile';
import { ICmsPage } from '../../../../_models/cms/ICmsPage';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-cms-page-form',
  templateUrl: './cms-page-form.component.html'
})
export class CmsPageFormComponent implements OnInit {

  loading: boolean;
  title: string = 'Add Page';
  cmsPage: ICmsPage;
  cmsPageForm: FormGroup;
  cmsPages: ICmsPage[];
  selectedMediaFileThumb: IMediaFile | null;
  id;

  barWidth: number = 0;
  isProgress: boolean = false;
  fileToUpload: File = null;
  
  sub: Subscription;
  editorConfigOption: AngularEditorConfig;
  windowObjRef;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: CmsPageService,
    private mediaFileService: MediaFileService,
    private editorConfigService: EditorConfigService) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.editorConfigOption = this.editorConfigService.getOption();

    this.createCmsPageForm();
    this.bindDropDown();
    if (this.id) this.service.get(this.id).subscribe((response: ICmsPage) => {
      if (response) {
        this.cmsPage = response;
        this.title = 'Edit Page';
        if (response.mediaFileThumbId) this.selectedMediaFileThumb = response.mediaFileThumb;
        this.setValueCmsPageForm();
      }
    });

    this.sub = this.mediaFileService.selectedMediaFileChanges$.subscribe(
      selectedMediaFile => {
        if (selectedMediaFile) {
          this.selectedMediaFileThumb = selectedMediaFile;
          this.cmsPageForm.patchValue({
            mediaFileThumbId: selectedMediaFile.id
          });
        }
      }
    );
  }

  ngOnDestroy() {
    this.mediaFileService.changeSelectedMediaFile(null);
  }

  bindDropDown() {
    this.service.getAllCmsPagesForAdmin().subscribe((response: ICmsPage[]) => {
      if (response) {
        this.cmsPages = response;
      }
    });
  }

  
  createCmsPageForm() {
    this.cmsPageForm = this.fb.group({
      id: ['0', Validators.required],
      title: ['', Validators.required],
      slug: ['', Validators.required],
      content: ['<p>Type here..</p>', Validators.required],
      css: [''],
      mediaFileThumbId: [''],
      parentCmsPageId: [''],
      isCommingSoon: ['false']
    });
  }

  setValueCmsPageForm() {
    this.cmsPageForm.patchValue({
      id: this.cmsPage.id,
      title: this.cmsPage.title,
      slug: this.cmsPage.slug,
      content: this.cmsPage.content,
      css: this.cmsPage.css,
      mediaFileThumbId: this.cmsPage.mediaFileThumbId,
      parentCmsPageId: this.cmsPage.parentCmsPageId ? this.cmsPage.parentCmsPageId : '',
      isCommingSoon: this.cmsPage.isCommingSoon
    });
  }

  openPreview() {
    if (!this.windowObjRef) {
      this.windowObjRef = window.open('/page/' + this.cmsPage.slug);
    }
    else {
      if (!this.windowObjRef.closed) {
        this.windowObjRef.location.reload();
      }
      else {
        this.windowObjRef = window.open('/page/' + this.cmsPage.slug);
      }
    }
  }

  savePreview() {
    this.save(false);
  }

  save(is_preview: boolean = true) {
    if (this.cmsPageForm.valid) {
      this.loading = true;
      this.cmsPage = Object.assign({}, this.cmsPageForm.value);
      if (this.id) {
        this.service.update(this.id, this.cmsPage).subscribe(() => {
          if (is_preview) {
            this.toastrService.success('Page updated successful');
            this.router.navigate(['/admin/cms-pages']);
          }
          else {
            this.openPreview();
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.cmsPage).subscribe(() => {
          if (is_preview) {
            this.toastrService.success('Page created successful');
            this.router.navigate(['/admin/cms-pages']);
          }
          else {
            this.openPreview();
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this page?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('Page deleted successful');
      this.router.navigate(['/admin/cms-pages']);
    });
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }

  OnSubmit(inputDoc) {

    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          console.log(event.body);
          this.cmsPageForm.patchValue({
            mediaFileThumbId: event.body.id
          });
        }
      },
      (error) => {
        console.log(error);
        inputDoc.value = null;
      },
      () => console.log("complete"));
  }

}
